import PropertyTabContainer from "../../../../components/property/detail/PropertyTab";

const PropertyTab = () => {
  return <PropertyTabContainer />;
};

export default PropertyTab;
